import React, {useEffect, useState} from 'react';
import DialogMUI from '../../../shared/DialogMUI';
import ButtonMUI from '../../../shared/ButtonMUI';
import {useDispatch, useSelector} from 'react-redux';
import {closeModalAdditional} from '../../../redux/actions/app/appActions';
import {ReactComponent as ArrowLeft} from '../../../assets/icons/arrowLeft.svg';
import './AvatarPopup.scss';
import {useTranslation} from 'react-i18next';

const AvatarPopup = ({setAvatar, avatar, images, path}) => {
    const {t} = useTranslation();
    const [avatarIcon, setAvatarIcon] = useState({});
    const dispatch = useDispatch();
    const additionalPopupShow = useSelector(({app}) => app.additionalPopupShow);

    const onCloseHandler = () => {
        dispatch(closeModalAdditional());
    };

    const handleSubmit = () => {
        onCloseHandler();
        setAvatar(avatarIcon);
    };


    const handleSetAvatar = async (avatar) => {
        setAvatarIcon(avatar);
    };

    const popupVisible = path === additionalPopupShow;

    useEffect(() => {
        if (avatar && !Object.keys(avatar).length) {
            setAvatarIcon({});
        }
    }, [avatar, popupVisible]);

    useEffect(() => {
        if (avatar?.id && popupVisible) {
            setAvatarIcon(avatar);
        }
        return () => {
            if (!popupVisible) {
                setAvatarIcon({});
            }
        }
    }, [avatar, popupVisible]);

    return (
        <div className={'avatar_popup'}>
            <DialogMUI open={popupVisible} onClose={onCloseHandler} title={t('AvatarPopup.chooseAvatar')}>
                <div className='avatar__back' onClick={onCloseHandler}>
                    <div className='avatar__arrow'>
                        <ArrowLeft/>
                    </div>
                    {t('AvatarPopup.return')}
                </div>
                <div className='avatar__list'>
                    {images?.map((image) => {
                        return (
                            <div
                                key={image.id}
                                className={`avatar__item ${image?.id === avatarIcon.id ? 'active' : ''}`}
                                onClick={() => {
                                    handleSetAvatar(image);
                                }}
                            >
                                <img src={image.avatar} alt={image.id}/>
                            </div>
                        );
                    })}
                </div>
                <div className='avatar__submit'>
                    <ButtonMUI onClick={handleSubmit} disabled={Object.keys(avatarIcon).length === 0} fullWidth={true}>
                        {t('AvatarPopup.select')}
                    </ButtonMUI>
                </div>
            </DialogMUI>
        </div>
    );
};

export default AvatarPopup;
